import { useForm } from "react-hook-form";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import Modal from "./Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerCentrosEducativos,
  actualizarCentrosEducativos,
  agregarCentrosEducativos,
  obtenerInfoGeografica,
  eliminarCentrosEducativos,
} from "../../redux/centrosEducativosSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import LoadingSpiner from "../../Components/LoadingSpiner";
import ReactSelect from "../../Components/ReactSelect";
import ModalRemove from "./ModalRemove";
import Required from "../../Components/Required";
import { OrderTable } from "../../Components/OrderTable";
import useSubmit from "../../Hooks/useSubmit";
import { getAdminEducenterPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { _translateValue } from "../translation-gestor/translateValue";

import { useValidation } from "../../Hooks/useValidation";

const SCREEN_NAME = "PantallaCentrosEducativos";
// columns are computed inside the component using useMemo

const paisId = 192;

function CentrosEducativos(props) {
  const { validation } = useValidation();
  const { width } = WindowDimension();
  const { locale } = useLocale();
  const [adminEducenterPage, setAdminEducenterPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [translatedPaises, setTranslatedPaises] = useState({});
  const [translatedTiposOrganizaciones, setTranslatedTiposOrganizaciones] = useState({});
  const [translatedDirecciones, setTranslatedDirecciones] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [listaProvincia, setListaProvincia] = useState([]);
  const [listaDistrito, setListaDistrito] = useState([]);
  const [listaCantones, setListaCantones] = useState([]);
  const [listaTiposOrganizaciones, setListaTiposOrganizaciones] = useState([]);
  const [listaTipos, setListaTipos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [cantones, setCantones] = useState([]);
  const [tituloModal, setTituloModal] = useState("");
  const [cantonId, setCantonId] = useState(0);
  const [provinciaId, setProvinciaId] = useState(0);
  const [removeState, changeRemoveState] = useState(false);
  const [itemSelected, setItemSelected] = useState({});

  const { submitAction } = useSubmit();

  const columns = useMemo(() => {
    const table = adminEducenterPage?.educenter_table ?? [];
    return [
      { label: table[0]?.label || "Código", accessor: "centroEducativoId", sortable: true },
      { label: table[1]?.label || "Nombre", accessor: "centroEducativoNombre", sortable: true },
      { 
        label: table[2]?.label || "País", 
        accessor: "paisNombre", 
        sortable: true,
        render: (item) => (
          <td>{translatedPaises[item.paisNombre] || item.paisNombre}</td>
        ),
      },
      { label: table[3]?.label || "Provincia", accessor: "provinciaNombre", sortable: true },
      { label: table[4]?.label || "Cantón", accessor: "cantonNombre", sortable: true },
      { label: table[5]?.label || "Distrito", accessor: "distritoNombre", sortable: true },
      {
        label: table[6]?.label || "Tipo de organización",
        accessor: "tipoOrganizacionNombre",
        sortable: true,
        render: (item) => (
          <td>{translatedTiposOrganizaciones[item.tipoOrganizacionNombre] || item.tipoOrganizacionNombre}</td>
        ),
      },
      { 
        label: table[7]?.label || "Dirección", 
        accessor: "direccion", 
        sortable: true,
        render: (item) => (
          <td>{translatedDirecciones[item.direccion] || item.direccion}</td>
        ),
      },
      { label: table[8]?.label || "Acción", accessor: "action", sortable: false },
    ];
  }, [adminEducenterPage, translatedPaises, translatedTiposOrganizaciones, translatedDirecciones]);

  const dispatch = useDispatch();
  const { centrosEducativos, loading, model } = useSelector(
    (state) => state.centrosEducativos
  );
  let busqueda = useRef();

  const cargarDatos = useCallback(() => {
    let obj = {
      q: "",
      paisId: paisId,
      provinciaId: provinciaId,
      cantonId: cantonId,
      centroEducativoId: 0,
    };
    dispatch(obtenerCentrosEducativos(obj));
  }, [dispatch, provinciaId, cantonId]);

  useEffect(() => {
    cargarDatos();
    dispatch(obtenerInfoGeografica());
  }, [dispatch, cargarDatos]);

  useEffect(() => {
    let b = model?.provincias?.map((item, i) => {
      return { label: item.provinciaNombre, value: item.provinciaId };
    });
    setListaProvincia(b);

    let c = model?.cantones?.map((item, i) => {
      return { label: item.cantonNombre, value: item.cantonId };
    });
    setListaCantones(c);
    let d = model?.distritos?.map((item, i) => {
      return { label: item.distritoNombre, value: item.distritoId };
    });
    setListaDistrito(d);
    let e = model?.tiposOrganizaciones?.map((item, i) => {
      return {
        label: item.tipoOrganizacionNombre,
        value: item.tipoOrganizacionId,
      };
    });
    setListaTiposOrganizaciones(e);
    let f = model?.centroEducativoTipos?.map((item, i) => {
      return { label: item.tipoNombre, value: item.tipoId };
    });
    setListaTipos(f);

    setProvincias(model.provincias);
    setCantones(model.cantones);
  }, [model]);

  const {
    register,
    control,
    watch,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      centroEducativoId: 0,
      centroEducativoNombre: "",
      paisId: undefined,
      provinciaId: undefined,
      cantonId: undefined,
      distritoId: undefined,
      tipoOrganizacionId: undefined,
      poblado: "",
      zona: "",
      telefono: "",
      direccion: "",
      circuito: "",
    },
  });

  const mProvinciaId = watch("provinciaId");
  const mCantonId = watch("cantonId");

  useEffect(() => {
    let c = model?.cantones
      ?.filter((a) => a.provinciaId === mProvinciaId)
      ?.map((item, i) => {
        return { label: item.cantonNombre, value: item.cantonId };
      });
    setListaCantones(c);
  }, [mProvinciaId, model?.cantones]);
  useEffect(() => {
    let c = model?.distritos
      ?.filter((a) => a.cantonId === mCantonId)
      ?.map((item, i) => {
        return { label: item.distritoNombre, value: item.distritoId };
      });
    setListaDistrito(c);
  }, [mCantonId, model?.distritos]);

  const cargarCantonesPorProvincia = (e) => {
    let id = e.target.value;
    setProvinciaId(id);
    let cantones = model?.cantones.filter((a) => a.provinciaId === id);
    setCantones(cantones);
    let obj = {
      q: busqueda.current.value,
      paisId: paisId,
      provinciaId: id,
      cantonId: cantonId,
      centroEducativoId: 0,
    };
    dispatch(obtenerCentrosEducativos(obj));
  };
  const cargarCentrosEducativos = (e) => {
    let id = e.target.value;
    setCantonId(id);
    let obj = {
      q: busqueda.current.value,
      paisId: paisId,
      provinciaId: provinciaId,
      cantonId: id,
      centroEducativoId: 0,
    };
    dispatch(obtenerCentrosEducativos(obj));
  };
  const cargarCarrerasBusqueda = () => {
    let obj = {
      q: busqueda.current.value,
      paisId: paisId,
      provinciaId: provinciaId,
      cantonId: cantonId,
      centroEducativoId: 0,
    };
    dispatch(obtenerCentrosEducativos(obj));
  };
  const showModalEdit = (item) => {
    reset(item);
    setShowModal(true);
  };
  const closeModalEdit = () => {
    reset({
      centroEducativoId: 0,
      centroEducativoNombre: "",
      paisId: undefined,
      provinciaId: undefined,
      cantonId: undefined,
      distritoId: undefined,
      tipoOrganizacionId: undefined,
      poblado: "",
      zona: "",
      telefono: "",
      direccion: "",
      circuito: "",
    });
    setShowModal(false);
  };
  const showRemoveModalEdit = (item) => {
    setItemSelected(item);
    changeRemoveState(true);
  };
  const closeRemoveModalEdit = () => {
    setItemSelected({});
    changeRemoveState(false);
  };

  const onSubmit = async (data) => {
    data.paisId = paisId;

    submitAction(
      data.centroEducativoId > 0
        ? actualizarCentrosEducativos
        : agregarCentrosEducativos,
      data.centroEducativoId > 0
        ? { item: data, id: data.centroEducativoId }
        : data,
      () => {
        cargarDatos();
        closeModalEdit();
      }
    );
  };
  const eliminar = async () => {
    submitAction(
      eliminarCentrosEducativos,
      itemSelected.centroEducativoId,
      () => {
        closeRemoveModalEdit();
        cargarDatos();
      }
    );
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getAdminEducenterPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminEducenterPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setAdminEducenterPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  // Efecto para traducir los campos "País", "Tipo de organización" y "Dirección" cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      // Verificar si hay datos para traducir
      const hasCentros = centrosEducativos && Array.isArray(centrosEducativos) && centrosEducativos.length > 0;

      // Si no hay datos, no hacer nada
      if (!hasCentros) {
        setIsTranslating(false);
        return;
      }

      // Iniciar traducción
      setIsTranslating(true);

      const paisTranslations = {};
      const tipoOrganizacionTranslations = {};
      const direccionTranslations = {};

      // Traducir solo los campos solicitados
      const translationPromises = centrosEducativos.map(async (item) => {
        if (item.paisNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.paisNombre, locale);
          paisTranslations[item.paisNombre] = translated;
        }
        if (item.tipoOrganizacionNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.tipoOrganizacionNombre, locale);
          tipoOrganizacionTranslations[item.tipoOrganizacionNombre] = translated;
        }
        if (item.direccion) {
          const translated = await _translateValue(SCREEN_NAME, item.direccion, locale);
          direccionTranslations[item.direccion] = translated;
        }
      });
      await Promise.all(translationPromises);

      // Actualizar estados y finalizar traducción
      setTranslatedPaises(paisTranslations);
      setTranslatedTiposOrganizaciones(tipoOrganizacionTranslations);
      setTranslatedDirecciones(direccionTranslations);
      setIsTranslating(false);
    };

    translateData();
  }, [centrosEducativos, locale]);

  if (isLoadingContent || isTranslating) {
    return (
      <div className="main-admin">
        <div className="main-admin-bar">
          <Skeleton.Button style={{ width: 40, height: 40 }} active />
          <Skeleton.Input style={{ width: 300, height: 30 }} active />
          <div className="header-admin-bar-items ml-auto">
            <Skeleton.Input style={{ width: 150, height: 40 }} active />
            <Skeleton.Input style={{ width: 150, height: 40 }} active />
            <Skeleton.Input style={{ width: 200, height: 40 }} active />
          </div>
        </div>
        <div className="table-container">
          <Skeleton.Input style={{ width: '100%', height: 400, minWidth: '800px' }} active />
        </div>
      </div>
    );
  }

  return (
    <div className="main-admin">
      <div className="main-admin-bar">
        <button
          className="main-admin-button"
          onClick={() => {
            setShowModal(true);
            setTituloModal(adminEducenterPage?.addEduCenter?.title || "Centro educativo");
            reset();
          }}
        >
          +
        </button>

        <h2>{adminEducenterPage?.title || "Centros educativos"}</h2>
        <div className="header-admin-bar-items ml-auto">
          <label hidden>provincias</label>
          <select onChange={cargarCantonesPorProvincia}>
            <option value="0">{adminEducenterPage?.select_optionA || "Todas las provincias"}</option>
            {provincias?.map((item, i) => {
              return (
                <option key={i} value={item.provinciaId}>
                  {item.provinciaNombre}
                </option>
              );
            })}
          </select>
          <label hidden>Cantones</label>
          <select onChange={cargarCentrosEducativos}>
            <option value="0">{adminEducenterPage?.select_optionB || "Todos los cantones"}</option>
            {cantones?.map((item, i) => {
              return (
                <option key={i} value={item.cantonId}>
                  {item.cantonNombre}
                </option>
              );
            })}
          </select>

          <label hidden>Búsqueda</label>
          <input
            className="centro-search"
            type="search"
            placeholder={adminEducenterPage?.search_input || "Búsqueda"}
            onInput={cargarCarrerasBusqueda}
            ref={busqueda}
          />
        </div>
      </div>

      <div className="table-container">
        {loading ? (
          <div className="align-spinner">
            <LoadingSpiner
              styles={{
                width: "45px",
                height: "45px",
                border: "6px solid #bbbbbb",
                borderTop: "6px solid #035cc9",
              }}
            />
          </div>
        ) : centrosEducativos?.length > 0 ? (
          <>
            <OrderTable
              {...{ columns }}
              data={centrosEducativos}
              clase="table-adm"
              actions={[
                {
                  icon: "",
                  clase: "text-primary",
                  event: (item) => showModalEdit(item),
                },
                {
                  icon: "",
                  clase: "text-primary",
                  event: (item) => showRemoveModalEdit(item),
                },
              ]}
            />
          </>
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>

      <Modal
        estado={showModal}
        cambiarEstado={closeModalEdit}
        titulo={tituloModal}
        clase={`${width < 576 ? "full-width" : "medium"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(onSubmit)}
            >
              {adminEducenterPage?.addEduCenter?.save_button || "Guardar"}
            </button>
          </>
        }
      >
        <form>
          <div className="grid-container col-4 col-lg-2 col-sm-12">
            <div className="grid-item">
                <div className="form-group">
                  <label>{adminEducenterPage?.addEduCenter?.name || "Nombre"}</label>
                <Required />
                <input
                  {...register("centroEducativoNombre", {
                    required: validation?.required_field || "Campo requerido",
                  })}
                  className="form-control"
                  type="text"
                />

                {errors.paisId && (
                  <p className="error">{errors.paisId.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.province || "Provincia"}</label>
                <Required />
                <ReactSelect
                  name="provinciaId"
                  control={control}
                  lista={listaProvincia}
                  rules={{ required: validation?.required_field || "Campo requerido" }}
                />
                {errors.provinciaId && (
                  <p className="error">{errors.provinciaId.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.canton || "Cantón"}</label>
                <Required />
                <ReactSelect
                  name="cantonId"
                  control={control}
                  lista={listaCantones}
                  rules={{ required: validation?.required_field || "Campo requerido" }}
                />
                {errors.cantonId && (
                  <p className="error">{errors.cantonId.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.district || "Distrito"}</label>
                <Required />
                <ReactSelect
                  name="distritoId"
                  control={control}
                  lista={listaDistrito}
                  rules={{ required: validation?.required_field || "Campo requerido" }}
                />
                {errors.distritoId && (
                  <p className="error">{errors.distritoId.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.orgType || "Tipo organización"}</label>
                <Required />
                <ReactSelect
                  name="tipoOrganizacionId"
                  control={control}
                  lista={listaTiposOrganizaciones}
                  rules={{ required: validation?.required_field || "Campo requerido" }}
                />
                {errors.tipoOrganizacionId && (
                  <p className="error">{errors.tipoOrganizacionId.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.level || "Nivel"}</label>
                <Required />
                <ReactSelect
                  name="tipoId"
                  control={control}
                  lista={listaTipos}
                  rules={{ required: validation?.required_field || "Campo requerido" }}
                />
                {errors.tipoId && (
                  <p className="error">{errors.tipoId.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.town || "Poblado"}</label>
                <Required />
                <input
                  {...register("poblado", { required: validation?.required_field || "Campo requerido" })}
                  className="form-control"
                  type="text"
                />
                {errors.poblado && (
                  <p className="error">{errors.poblado.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.zone || "Zona"}</label>
                <Required />
                <input
                  {...register("zona", { required: validation?.required_field || "Campo requerido" })}
                  className="form-control"
                  type="text"
                />
                {errors.zona && <p className="error">{errors.zona.message}</p>}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.phonenumber || "Teléfono"}</label>
                <Required />
                <input
                  {...register("telefono", { required: validation?.required_field || "Campo requerido" })}
                  className="form-control"
                  type="text"
                />
                {errors.telefono && (
                  <p className="error">{errors.telefono.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.direction || "Dirección"}</label>
                <Required />
                <input
                  {...register("direccion", { required: validation?.required_field || "Campo requerido" })}
                  className="form-control"
                  type="text"
                />
                {errors.direccion && (
                  <p className="error">{errors.direccion.message}</p>
                )}
              </div>
            </div>
            <div className="grid-item">
              <div className="form-group">
                <label>{adminEducenterPage?.addEduCenter?.circuit || "Circuito"}</label>
                <Required />
                <input
                  {...register("circuito", { required: validation?.required_field || "Campo requerido" })}
                  className="form-control"
                  type="text"
                />
                {errors.circuito && (
                  <p className="error">{errors.circuito.message}</p>
                )}
              </div>
            </div>
          </div>
        </form>
      </Modal>

      <ModalRemove
        estado={removeState}
        closeModalHandled={closeRemoveModalEdit}
        title={adminEducenterPage?.subtitle || "Eliminar centro educativo"}
        message={adminEducenterPage?.question || "¿Seguro que desea eliminar el siguiente registro?"}
        item={itemSelected.centroEducativoNombre}
        btnGroup={
          <>
            <button className="button-text text-red" onClick={eliminar}>
              {adminEducenterPage?.confirm_button || "Confirmar"}
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                closeRemoveModalEdit(false);
              }}
            >
              {adminEducenterPage?.cancel_button || "Cancelar"}
            </button>
          </>
        }
      />
    </div>
  );
}

export default CentrosEducativos;
